import React from "react";
import "./Error404.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

function Error404() {
  return (
    <>
      <Header />
      <section className="error404">
        <div className="container">
           <img src="../images/svg/error404.svg" alt="" /> 
           <div className="error404__data">
            <h1>OOPS, PAGE NOT FOUND</h1>
            <p>This page doesn’t exist or was removed. Please go back to the homepage.</p>
            <button className="button">Go Home</button>
           </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Error404;
